export const margin = { top: 40, right: 16, bottom: 20, left: 16 };
export const width = 480;

export const devicePixelRatio = window.devicePixelRatio || 1;

export const smallText = "13px";
export const mediumText = "14px";
export const largeText = "20px";
